"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiButtonGroup = exports.MuiButton = exports.MuiButtonBase = void 0;
var colors_1 = require("../colors");
exports.MuiButtonBase = {
    styleOverrides: {
        root: {
            '&.MuiPickersDay-root.Mui-selected': {
                // Selected state styles
                '&:focus': {
                    ':focus-visible': {
                        backgroundColor: colors_1.tannerPurple['600'],
                        color: colors_1.tannerWhite,
                    },
                },
                '&:hover': {
                    backgroundColor: colors_1.tannerPurple['600'],
                },
            },
            '&.MuiPickersDay-dayWithMargin': {
                // Day with margin styles
                '&:focus': {
                    ':focus-visible': {
                        outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                        outlineOffset: 3,
                        transition: 'outline-offset 150ms',
                        backgroundColor: colors_1.tannerGray['100'],
                        zIndex: 1,
                    },
                },
                '&.MuiPickersDay-today': {
                    // Today's date styles
                    border: '2px solid' + colors_1.tannerWhite,
                    outline: '1px solid' + colors_1.tannerGray['300'],
                    backgroundColor: colors_1.tannerWhite,
                    color: colors_1.tannerBlack,
                    '&:hover': {
                        backgroundColor: colors_1.tannerGray['100'],
                    },
                    '&:focus': {
                        ':focus-visible': {
                            outline: '2px solid' + colors_1.tannerWhite,
                            border: '1px solid' + colors_1.tannerGray['300'],
                            boxShadow: '0 0 0 4px ' + colors_1.tannerSemantic.info.color,
                            backgroundColor: colors_1.tannerWhite,
                            color: colors_1.tannerBlack,
                        },
                        ':not(:focus-visible)': {
                            backgroundColor: 'inherit',
                            color: 'inherit',
                        },
                    },
                },
            },
        },
    },
};
exports.MuiButton = {
    defaultProps: {
        variant: 'contained',
        color: 'primary',
        disableElevation: true,
        disableFocusRipple: true,
    },
    variants: [
        {
            props: { color: 'white' },
            style: {
                color: '#000',
                backgroundColor: colors_1.tannerWhite,
                '&.Mui-disabled': {
                    color: '#000',
                    backgroundColor: colors_1.tannerWhite,
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: colors_1.tannerGray['200'],
                },
            },
        },
        {
            props: { color: 'black' },
            style: {
                color: colors_1.tannerWhite,
                backgroundColor: '#000',
                '&.Mui-disabled': {
                    color: colors_1.tannerWhite,
                    backgroundColor: '#000',
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: colors_1.tannerGray['700'],
                },
            },
        },
        {
            props: { color: 'blue' },
            style: {
                color: colors_1.tannerWhite,
                backgroundColor: colors_1.tannerBlue['500'],
                '&.Mui-disabled': {
                    color: '#D9E7FA',
                    backgroundColor: '#668CEC',
                },
                ':disabled': {
                    backgroundColor: '#BCD5F8',
                    color: "".concat(colors_1.tannerSemantic.info.background),
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: '#0049AB',
                },
            },
        },
        {
            props: { color: 'error' },
            style: {
                backgroundColor: "".concat(colors_1.tannerSemantic.error.color),
                ':disabled': {
                    backgroundColor: '#EC8D90',
                    color: "".concat(colors_1.tannerSemantic.error.background),
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: '#B00007',
                },
            },
        },
    ],
    styleOverrides: {
        root: {
            fill: 'currentColor',
            borderRadius: 3,
            fontWeight: 800,
            fontSize: 14,
            padding: '7px 16px',
            textTransform: 'initial',
            minHeight: '40px',
            lineHeight: '140%',
            border: '2px solid transparent',
            '&.Mui-disabled': {
                opacity: 0.4,
            },
            '&:focus-visible': {
                outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                outlineOffset: 3,
                transition: 'outline-offset 150ms',
            },
        },
        iconSizeMedium: {
            '& > *:first-of-type': {
                fontSize: 16,
            },
        },
        textSizeSmall: {
            minWidth: 0,
            padding: '0 8px',
            '&:hover:after': {
                backgroundColor: 'currentColor',
                content: '""',
                opacity: 0.2,
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                borderRadius: 3,
            },
        },
        text: {
            alignItems: 'center',
            borderRadius: 3,
            display: 'inline-flex',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '140%',
            padding: '0 6px',
            '& .MuiButton-startIcon': {
                marginLeft: 0,
            },
            '& .MuiButton-endIcon': {
                marginRight: 0,
            },
        },
        containedPrimary: {
            '&.Mui-disabled': {
                backgroundColor: 'inherit',
            },
        },
        containedSecondary: {
            '&:hover, &:focus-visible': {
                backgroundColor: colors_1.tannerGray['300'],
            },
        },
        textPrimary: {
            color: colors_1.tannerSemantic.info.color,
            '&:hover, &:focus-visible': {
                backgroundColor: colors_1.tannerSemantic.info.background,
            },
            '&.Mui-disabled': {
                color: colors_1.tannerSemantic.info.color,
            },
        },
        textSecondary: {
            color: colors_1.tannerGray['600'],
            '&:hover, &:focus-visible': {
                color: colors_1.tannerGray['900'],
                backgroundColor: colors_1.tannerGray['100'],
            },
            '&$disabled': {
                color: colors_1.tannerGray['400'],
            },
        },
        colorSecondary: {
            color: colors_1.tannerWhite,
        },
    },
};
exports.MuiButtonGroup = {
    defaultProps: {
        variant: 'contained',
        color: 'primary',
        disableElevation: true,
        disableFocusRipple: true,
    },
    styleOverrides: {
        groupedContainedPrimary: {
            '&:last-child': {
                paddingLeft: 8,
                paddingRight: 8,
                minWidth: 34,
                margin: '2px 2px 2px 0',
            },
            '&:not(:last-child)': {
                borderColor: colors_1.tannerWhite,
            },
        },
        groupedContainedSecondary: {
            '&:last-child': {
                paddingLeft: 8,
                paddingRight: 8,
                minWidth: 34,
                margin: '2px 2px 2px 0',
            },
            '&:not(:last-child)': {
                borderColor: colors_1.tannerWhite,
            },
        },
    },
};
//# sourceMappingURL=MuiButton.js.map